export default __webpack_public_path__ + "static/media/background_yellow.15105c77.png";